var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#2F92D0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.292 6.245L11 10.115l8.708-3.87M11 10.116v11.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.708 17.856L11 21.726l-8.708-3.87V6.246L11 2.374l8.708 3.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitsBlue);
export default __webpack_public_path__ + "static/media/units-blue.a6aa5c7ab6f0a16ee0706d0e4b45174f.svg";
export { ForwardRef as ReactComponent };